const formattedDateForBrowsers = (date, withTime = false) => {
    if(date) {
        if (withTime) {
            return date.replace(/ /g, "T") + "Z";
        }
        return date.replace(/ /g, "T");
    }
    return  date;
}

export {
    formattedDateForBrowsers
}
